<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="col-6">
        <!-- Vehicle category -->
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable">Vehicle category</label>
          <div class="p-col">
            <!-- EDIT: hiển thị như column list (text) -->
            <InputText
              v-if="isEdit"
              :disabled="true"
              v-model="display.vehicle_category_name"
              placeholder="Vehicle category"
            />

            <!-- ADD: chọn category -->
            <v-select
              v-else
              :key="key_vehicle_category"
              :clearable="false"
              class=""
              @search="SearchVehicleCategory"
              placeholder="Choose"
              v-model="obj_data.vehicle_category_id"
              :options="list_vehicle_category_id"
              :reduce="(item) => item.id"
              label="name"
              @input="change_list_vehicle_category"
            >
              <span slot="no-options" @click="$refs.select && ($refs.select.open = false)">Empty data</span>
            </v-select>

            <input v-if="!isEdit" class="input_tmp_validator" id="tmp_rent_vehicle_category_id" />
          </div>
        </div>

        <!-- License plate number -->
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable">License plate number</label>
          <div class="p-col">
            <!-- EDIT: text -->
            <InputText
              v-if="isEdit"
              :disabled="true"
              v-model="display.license_plate_number"
              placeholder="License plate number"
            />

            <!-- ADD: select car_for_rent -->
            <v-select
              v-else
              :key="key_car_for_rent"
              :clearable="false"
              class=""
              @search="SearchCarForRent"
              placeholder="Choose"
              v-model="obj_data.car_for_rent_id"
              :options="list_car_for_rent_id"
              :reduce="(item) => item.id"
              label="license_plate_number"
              @input="change_car_for_rent"
            >
              <span slot="no-options" @click="$refs.select && ($refs.select.open = false)">Empty data</span>
            </v-select>

            <input v-if="!isEdit" class="input_tmp_validator" id="tmp_car_for_rent_id" />
          </div>
        </div>

        <!-- Renter name -->
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required txt_style_lable">Renter name</label>
          <div class="p-col">
            <!-- EDIT: text -->
            <InputText
              v-if="isEdit"
              :disabled="true"
              v-model="display.contact_name"
              placeholder="Renter name"
            />

            <!-- ADD: select user -->
            <v-select
              v-else
              :clearable="true"
              class=""
              @search="SearchUser"
              placeholder="Choose"
              v-model="obj_data.renter_id"
              :options="listUser"
              :reduce="(item) => item.id"
              label="fullname"
              @input="change_list_user"
            >
              <span slot="no-options" @click="$refs.select && ($refs.select.open = false)">Empty data</span>
            </v-select>

            <input v-if="!isEdit" class="input_tmp_validator" id="tmp_renter_id" />
          </div>
        </div>

        <!-- Phone -->
        <div class="p-card-field">
          <label class="class-bold1 p-col-fixed txt-right">Phone</label>
          <div class="p-col">
            <InputText :disabled="true" v-model="display.contact_phone" />
          </div>
        </div>

        <!-- Accident date -->
        <div class="p-card-field">
          <label class="class-bold1 p-col-fixed txt-right">Accident date</label>
          <div class="p-col">
            <Calendar
              v-model="obj_data.accident_date_at"
              dateFormat="dd/mm/yy"
              :showIcon="true"
              :manualInput="false"
              
              appendTo="body"
              placeholder="Choose"
            />
          </div>
        </div>

        <!-- Fixing date -->
        <div class="p-card-field">
          <label class="class-bold1 p-col-fixed txt-right">Fixing date</label>
          <div class="p-col">
            <Calendar
              v-model="obj_data.fixing_date_at"
              dateFormat="dd/mm/yy"
              :showIcon="true"
              :manualInput="false"
              
              appendTo="body"
              placeholder="Choose"
            />
          </div>
        </div>

        <!-- Status -->
        <div class="p-card-field">
          <label class="class-bold1 p-col-fixed txt-right">Status</label>
          <div class="p-col">
            <!-- EDIT: text -->
            <InputText v-if="isEdit" :disabled="true" v-model="display.status_text" placeholder="Status" />

            <!-- ADD: dropdown status (nếu bạn có constant) -->
            <v-select
              v-else
              :clearable="false"
              placeholder="Choose"
              v-model="obj_data.car_status"
              :options="$constants.CAR_FOR_RENT_STATUS"
              :reduce="(item) => item.value"
              label="label"
            >
              <span slot="no-options" @click="$refs.select && ($refs.select.open = false)">Empty data</span>
            </v-select>
          </div>
        </div>

        <!-- Expense -->
        <div class="p-card-field">
          <label class="class-bold1 p-col-fixed txt-right">Expense</label>
          <div class="p-col">
            <InputNumber
                  id="fee_fix"
                  placeholder="0"
                  v-model="obj_data.fee"
                  mode="decimal"
                  :minFractionDigits="2"
              />
          </div>
        </div>

        <!-- Notes (ONLY editable in EDIT) -->
        <div class="p-card-field">
          <label class="class-bold1 p-col-fixed txt-right">Notes</label>
          <div class="p-col">
            <Textarea
              id="note"
              maxLength="2000"
              rows="2"
              cols="30"
              :autoResize="true"
              class="ml-0"
              v-model="obj_data.note"
              placeholder="Input (max: 2,000 characters)"
              :disabled="false"
              @input="handleMaxCharacter('note', $event, 2000)"
            />
          </div>
        </div>
      </div>

      <!-- Buttons -->
      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button :label="$constants.TEXT_BUTTON.BACK" @click="backToList()" class="p-button-outlined" id="back" />
          <Button v-if="mode == 'edit'" id="edit" :label="$constants.TEXT_BUTTON.EDIT" @click="saveData()"
            class="main-style-button" />
          <Button v-else :label="$constants.TEXT_BUTTON.ADD" @click="saveData()" class="main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import moment from "moment-timezone";

export default {
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      obj_data: {
        vehicle_category_id: null,
        car_for_rent_id: null,
        renter_id: null,
        contact_name: "",
        contact_phone: "",
        accident_date_at: null,
        fixing_date_at: null,
        car_status: null, // join from car_for_rent.status hoặc field bạn dùng
        fee: 0,
        note: "", // nếu DB là notes => đổi thành notes
        rental_order_id: null,
      },

      display: {
        vehicle_category_name: "",
        license_plate_number: "",
        contact_name: "",
        contact_phone: "",
        status_text: "",
      },

      // list options
      list_vehicle_category_id: [],
      list_vehicle_category_id_all: [],
      map_vehicle_category_id_all: {},
      key_vehicle_category: 0,

      list_car_for_rent_id: [],
      list_car_for_rent_id_all: [],
      map_car_for_rent_id_all: {},
      key_car_for_rent: 0,

      listUser: [],
      listUserAll: [],
      mapUserAll: {},

      validationErrors: {},
    };
  },

  computed: {
    isEdit() {
      return this.mode === "edit";
    },
  },

  async mounted() {
    await Promise.all([this.getListUser(), this.getListVehicleCategory()]);

    // gắn data từ parent model
    if (this.model && Object.keys(this.model).length > 0) {
      const m = this.$commonFuction.convertJsonObject(this.model);

      // map base fields
      this.obj_data = {
        ...this.obj_data,
        ...m,
        fee: parseFloat(m.fee || 0),
        note: m.note || m.notes || "", // nếu DB dùng notes
      };

      // dates -> Calendar cần Date object
      if (m.accident_date_at) this.obj_data.accident_date_at = new Date(m.accident_date_at);
      if (m.fixing_date_at) this.obj_data.fixing_date_at = new Date(m.fixing_date_at);

      // build display like list columns
      this.display.vehicle_category_name =
        m?.vehicle_category_name ||
        m?.obj_vehicle_category?.name ||
        m?.obj_vehicle_category_name ||
        "";

      this.display.license_plate_number =
        m?.license_plate_number ||
        m?.obj_car_for_rent?.license_plate_number ||
        "";

      // renter
      this.display.contact_name =
        m?.contact_name ||
        m?.obj_renter?.fullname ||
        m?.obj_renter?.name ||
        "";

      this.display.contact_phone =
        m?.contact_phone ||
        m?.obj_renter?.phone ||
        "";

      // status text
      const st = m?.car_status || m?.obj_car_for_rent?.status || m?.status || null;
      this.obj_data.car_status = st;

      this.display.status_text =
        this.$constants?.CAR_FOR_RENT_STATUS?.find((x) => x.value === st)?.label ||
        (st ? `${st}` : "");

      // nếu ADD/EDIT vẫn cần options cho car list theo category
      await this.getListCarForRent();
    } else {
      // add mode: load car list default
      await this.getListCarForRent();
    }
  },

  methods: {
    backToList() {
      this.$emit("back");
    },

    handleMaxCharacter(field, event, maxLength = 255) {
      let value = event;
      if (typeof event === "object" && event?.target?.value !== undefined) value = event.target.value;
      value = value || "";
      if (value.length > maxLength) value = value.slice(0, maxLength);
      this.obj_data[field] = value;
    },

    async getListUser() {
      const where_key = {
        deleted: { _eq: false },
        role: { _eq: this.$constants.ROLE_ACCOUNT.USER },
      };
      const list = await this.$CoreService.getListUser(where_key);
      this.listUser = list?.list || [];
      this.listUserAll = list?.list || [];
      this.mapUserAll = list?.list_map || {};
    },

    async SearchUser(search) {
      if (search !== "" && search !== null) {
        const where_key = {
          deleted: { _eq: false },
          role: { _eq: this.$constants.ROLE_ACCOUNT.USER },
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.fullname_email = { _iregex: this.$commonFuction.search(search) };
        }
        const list = await this.$CoreService.getListUser(where_key);
        this.listUser = list?.list || [];
      } else {
        this.listUser = this.listUserAll;
      }
    },

    async change_list_user() {
      const u = this.mapUserAll?.[this.obj_data.renter_id] || null;
      if (u) {
        this.obj_data.contact_name = u.fullname || u.name || "";
        this.obj_data.contact_phone = u.phone || "";
        // update display too
        this.display.contact_name = this.obj_data.contact_name;
        this.display.contact_phone = this.obj_data.contact_phone;
      }
    },

    async getListVehicleCategory() {
      const where_key = { deleted: { _eq: false } };
      const list = await this.$CoreService.getLisVehicleCategory(where_key);
      this.list_vehicle_category_id = list?.list || [];
      this.list_vehicle_category_id_all = list?.list || [];
      this.map_vehicle_category_id_all = list?.map_list || {};
    },

    async SearchVehicleCategory(search) {
      if (search !== "" && search !== null) {
        const where_key = { deleted: { _eq: false } };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = { _iregex: this.$commonFuction.search(search) };
        }
        const list = await this.$CoreService.getLisVehicleCategory(where_key);
        this.list_vehicle_category_id = list?.list || [];
      } else {
        this.list_vehicle_category_id = this.list_vehicle_category_id_all;
      }
    },

    async change_list_vehicle_category() {
      // đổi category -> reset car
      this.obj_data.car_for_rent_id = null;
      await this.getListCarForRent();
      this.key_car_for_rent++;
    },

    async getListCarForRent() {
      const where_key = { deleted: { _eq: false } };
      if (!this.$commonFuction.isEmpty(this.obj_data.vehicle_category_id)) {
        where_key.vehicle_category_id = { _eq: this.obj_data.vehicle_category_id };
      }
      const list = await this.$CoreService.getListCarForRent(where_key);
      this.list_car_for_rent_id = list?.list || [];
      this.list_car_for_rent_id_all = list?.list || [];
      this.map_car_for_rent_id_all = list?.map_list || list?.list_map || {};
    },

    async SearchCarForRent(search) {
      if (search !== "" && search !== null) {
        const where_key = { deleted: { _eq: false } };
        if (!this.$commonFuction.isEmpty(this.obj_data.vehicle_category_id)) {
          where_key.vehicle_category_id = { _eq: this.obj_data.vehicle_category_id };
        }
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.license_plate_number = { _iregex: this.$commonFuction.search(search) };
        }
        const list = await this.$CoreService.getListCarForRent(where_key);
        this.list_car_for_rent_id = list?.list || [];
      } else {
        this.list_car_for_rent_id = this.list_car_for_rent_id_all;
      }
    },

    change_car_for_rent() {
      this.key_car_for_rent++;
      const car = this.map_car_for_rent_id_all?.[this.obj_data.car_for_rent_id] || null;
      if (car) {
        this.display.license_plate_number = car.license_plate_number || "";
        const st = car.status || null;
        this.obj_data.car_status = st;
        this.display.status_text =
          this.$constants?.CAR_FOR_RENT_STATUS?.find((x) => x.value === st)?.label || (st ? `${st}` : "");
      }
    },

    async validateData() {
      this.validationErrors = {};

      // ✅ Edit: chỉ update note => bỏ validate các field khác
      if (this.isEdit) return false;

      const tmp_vehicle = document.getElementById("tmp_rent_vehicle_category_id");
      if (tmp_vehicle) {
        tmp_vehicle.setCustomValidity(
          this.$commonFuction.isEmpty(this.obj_data.vehicle_category_id)
            ? this.$constants.MSG_TEXT.SELECT_INVALID_MSG
            : ""
        );
      }

      const tmp_renter = document.getElementById("tmp_renter_id");
      if (tmp_renter) {
        tmp_renter.setCustomValidity(
          this.$commonFuction.isEmpty(this.obj_data.renter_id)
            ? this.$constants.MSG_TEXT.SELECT_INVALID_MSG
            : ""
        );
      }

      const tmp_car = document.getElementById("tmp_car_for_rent_id");
      if (tmp_car) {
        tmp_car.setCustomValidity(
          this.$commonFuction.isEmpty(this.obj_data.car_for_rent_id)
            ? this.$constants.MSG_TEXT.SELECT_INVALID_MSG
            : ""
        );
      }

      const inpObj = document.getElementById("frm_action");
      if (inpObj && !inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
      return false;
    },

    async saveData() {
      this.$commonFuction.is_loading(true);

      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }

      // ✅ EDIT: chỉ gửi note
      if (this.isEdit) {
        const payload = {
          id: this.obj_data.id,
          note: this.obj_data.note || "", // nếu DB là notes => đổi thành notes
          fee: this.obj_data.fee || 0,
          accident_date_at: this.obj_data.accident_date_at ? this.obj_data.accident_date_at : null,
          fixing_date_at: this.obj_data.fixing_date_at ? this.obj_data.fixing_date_at : null,
        };
        
        console.log("this.obj_datathis.obj_data", this.obj_data);
        console.log("payload", payload);
        this.$emit("save", payload);
        this.$commonFuction.is_loading(false);
        return;
      }

      // ADD: format date
      const payload = { ...this.obj_data };

      if (payload.accident_date_at instanceof Date) {
        payload.accident_date_at = moment(payload.accident_date_at).format("YYYY-MM-DD");
      }
      if (payload.fixing_date_at instanceof Date) {
        payload.fixing_date_at = moment(payload.fixing_date_at).format("YYYY-MM-DD");
      }

      this.$emit("save", payload);
      this.$commonFuction.is_loading(false);
    },
  },
};
</script>

<style lang="scss">
.p-multiselect {
  width: 450px;
}

.p-multiselect-label:not(.p-placeholder) {
  padding-top: .25rem;
  padding-bottom: .25rem;
}

.category-item-value {
  padding: .25rem .5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: .2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}

.p-multiselect-label-container {
  height: 40px;
}

.p-inputtext {
  margin: 0px 0px 0px 4px;
}

@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}

div.p-card-field {
  padding: 0px !important;
}

.p-col-fixed {
  padding: 0px !important;
  margin: 0px 0px 0px 9px !important;
}

.input_text {
  width: 760px !important;
  height: 48px !important;
}


.multiselect {
  width: 760px !important;
}



.vs__clear {
  display: none;
}

.input_width {
  width: 760px !important;
  height: 48px !important;
}

#distance {
  width: 1px !important;
  height: 48px !important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #C8C8C8;
  border-radius: 0px;
}

.manager-title {
  font-size: 24px !important;
}

.input-dif {
  margin-left: 5px !important;
  border-top: 0px;
}

.p-inputgroup-addon {
  height: 48px;
}

.p-col-fixed {
  padding: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.margin {
  margin-bottom: 12px !important;
}

.border_color {
  border: 1px solid #C8C8C8;
}

.text {
  font-weight: normal !important;
  margin-left: 15px !important;
}

.div_check {
  margin-top: 12px !important;
}

//responsive
@media screen and (max-width: 600px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
    width: 100% !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }
}

@media screen and (max-width: 1000px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
  }
}

.p-button-outlined {
  .p-button-label {
    color: #FFDF01 !important;
  }
}

.service--product .vs__dropdown-toggle {
  height: 48px;
}

.class-bold1 {
  font-weight: bold;
}



.p-button-outlined .p-button-label {
    color: #000000 !important;
}
</style>
